import React from "react";
import "./AboutSection.css";



const AboutSection = () => {
  return (
    <div
      className="welcome-section"
      style={{ backgroundImage: `url("/images/tig-w.png")` }}
    >
      {/* Overlay */}
      <div className="welcome-overlay"></div>

      {/* Content */}
      <div className="welcome-content">
        <div className="welcome-logo">
          <img src="images/logo/logo-white.png" alt="Techno India Logo" />
        </div>

        <h1 className="welcome-title">
          Celebrating 40 Years of Trust
        </h1>

        <p className="welcome-text">
          It all started in the mid 1980s, inside a small room in Hooghly, as a training centre. Today, Techno India Group stands tall as a testament to the promise of delivering world-class education, in sync with the fast-changing, tech-first academic landscape. Four decades ago, the Roychowdhury brothers from Kapasdanga, Hooghly envisioned of an India, where students will be thriving at par with the global standards. With the passage of time, Techno India Group has not only become one of the leading knowledge ecosystems in modern India, but also expanded its area of expertise significantly to make impactful footprints in the domain of healthcare, hospitality, media, sports and consultancy.
        </p>

        {/* Partner Logos */}
        <div className="welcome-partners">
          <div className="partner-box">
            <img src="images/logo/snu.png" alt="snu" />
          </div>

          <div className="partner-box">
            <img src="images/logo/TGH_logo.png" alt="" />
          </div>

          <div className="partner-box">
            <img src="images/logo/football_school.png" alt="" />
          </div>

          <div className="partner-box">
            <img src="images/logo/retreat_logo.png" alt="" />
          </div>

          <div className="partner-box">
            <img src="images/logo/aajkaal_logo.png" alt="" />
          </div>

          {/* <div className="partner-box">
            <img src="images/logo/hatchlab.png" alt="" />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
